export default __webpack_public_path__ + "static/media/greentick.7da31f5a.svg";